import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Product } from '@spartacus/core';
import { ProductListItemContextSource } from '@spartacus/storefront';
import { ProductCardComponent } from '../../../../../product/product-card/product-card.component';


@Component({
  selector: 'cx-product-carousel-item',
  standalone: true,
  imports: [ProductCardComponent],
  templateUrl: './product-carousel-item.component.html',
  styleUrl: './product-carousel-item.component.scss',
})
export class CustomProductCarouselItemComponent implements OnChanges {
  @Input() item!: Product;

  constructor(protected productListItemContextSource: ProductListItemContextSource) {}

  ngOnChanges(changes?: SimpleChanges): void {
    if (changes?.['item']) {
      this.productListItemContextSource.product$.next(this.item);
    }
  }
}
